const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      // Cumulative Layout Shift
      getCLS(onPerfEntry);
      // First Input Delay
      getFID(onPerfEntry);
      // First Contentful Paint
      getFCP(onPerfEntry);
      // Largest Contentful Paint
      getLCP(onPerfEntry);
      // Time to First Byte
      getTTFB(onPerfEntry);
    });
  }
};

// Example usage:
// reportWebVitals(console.log);
// Or send to analytics:
// reportWebVitals((metric) => {
//   // Send to Analytics
//   if (window.gtag) {
//     window.gtag('event', name, {
//       value: Math.round(name === 'CLS' ? metric.value * 1000 : metric.value),
//       metric_id: metric.id,
//       metric_value: metric.value,
//       metric_delta: metric.delta,
//     });
//   }
// });

export default reportWebVitals;
